module.exports = __webpack_public_path__ + "img/dialog_image_S203P.9896d5ef.png";